module.exports = __webpack_public_path__ + "static/code-mobile-3865f98ff5721b645c171024bea0286e.jpg";